import * as React from "react";
const SvgHealth = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.58.525a.75.75 0 0 0-1.16 0c-.829 1.011-2.055 2.089-3.433 2.964-1.382.877-2.863 1.517-4.192 1.71-.8.115-1.545.781-1.545 1.715a18.864 18.864 0 0 0 6.467 14.219l2.79 2.432a.75.75 0 0 0 .986 0l2.79-2.432A18.864 18.864 0 0 0 21.75 6.914c0-.933-.743-1.597-1.537-1.72-1.247-.192-2.706-.801-4.098-1.662-1.387-.858-2.656-1.934-3.535-3.007ZM4.01 6.683C5.619 6.45 7.3 5.701 8.79 4.755A17.116 17.116 0 0 0 12 2.133c.932.984 2.096 1.914 3.326 2.675 1.498.926 3.149 1.636 4.659 1.869a.364.364 0 0 1 .205.105.19.19 0 0 1 .06.132c0 5.018-2.17 9.79-5.953 13.088L12 22.005l-2.297-2.003A17.364 17.364 0 0 1 3.75 6.914c0-.038.014-.083.059-.13a.351.351 0 0 1 .2-.1Zm8.24 9.817a.75.75 0 0 1-.75-.75V13H8.75a.75.75 0 0 1 0-1.5h2.75V8.75a.75.75 0 0 1 1.5 0v2.75h2.75a.75.75 0 0 1 0 1.5H13v2.75a.75.75 0 0 1-.75.75Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgHealth;
